import { Driver, AST, InformationSchema } from '@cotera/era';
import _ from 'lodash';
import { systemTablesForWriteSchema } from './system-tables';

export const reconcileSystemTables = async (params: {
  schema: string;
  driver: Driver.EraDriver;
}) => {
  const { schema, driver } = params;
  const tables = Object.values(systemTablesForWriteSchema(schema));
  return reconcileTables({ tables, driver });
};

export const reconcileTables = async (params: {
  tables: AST.TableDescription[];
  driver: Driver.EraDriver;
}): Promise<void> => {
  const { tables, driver } = params;
  if (tables.length === 0) {
    return;
  }

  const existingColumns = await InformationSchema({
    type: 'columns',
    schemas: _.uniq(tables.map((x) => x.schema)),
  })
    .where((t) => t.attr('table_name').oneOf(tables.map(({ name }) => name)))
    .execute(driver);

  const columnsByName = _.groupBy(existingColumns, (row) => row['table_name']);

  for (const table of tables) {
    const existingColumns = columnsByName[table.name];

    if (!existingColumns) {
      await driver.createTable(table);
    }
  }
};
